import { render, staticRenderFns } from "./TargetGroups.vue?vue&type=template&id=6b0943c2&"
import script from "./TargetGroups.vue?vue&type=script&lang=js&"
export * from "./TargetGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports